import React from "react";
import { founderData } from "../mock";
import { Linkedin, Twitter } from "lucide-react";

export const Team = () => {
  return (
    <div className="min-h-screen pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-slate-900 mb-4">
            Meet Our Team
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            The visionaries behind Kesho Studio, combining deep blockchain
            expertise with entrepreneurial excellence
          </p>
        </div>

        {/* Founders */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
          {founderData.map((founder) => (
            <div
              key={founder.id}
              className="group bg-white rounded-2xl overflow-hidden border border-slate-200 hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative h-96 overflow-hidden">
                <img
                  src={founder.image}
                  alt={founder.name}
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent"></div>
                <div className="absolute bottom-6 left-6 right-6">
                  <h3 className="text-3xl font-bold text-white mb-1">
                    {founder.name}
                  </h3>
                  <p className="text-orange-400 font-semibold text-lg">
                    {founder.role}
                  </p>
                </div>
              </div>
              <div className="p-8">
                <p className="text-slate-600 leading-relaxed mb-6">
                  {founder.bio}
                </p>
                <div className="flex gap-4">
                  <a
                    href={founder.linkedin}
                    className="inline-flex items-center justify-center w-10 h-10 bg-slate-100 rounded-full text-slate-700 hover:bg-orange-600 hover:text-white transition-colors"
                  >
                    <Linkedin size={20} />
                  </a>
                  <a
                    href={founder.twitter}
                    className="inline-flex items-center justify-center w-10 h-10 bg-slate-100 rounded-full text-slate-700 hover:bg-orange-600 hover:text-white transition-colors"
                  >
                    <Twitter size={20} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Team Culture */}
        <section className="bg-slate-50 rounded-2xl p-12 border border-slate-200">
          <h2 className="text-3xl font-bold text-slate-900 text-center mb-8">
            Our Culture
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🚀</span>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">
                Move Fast
              </h3>
              <p className="text-slate-600">
                We embrace agility and rapid iteration to stay ahead in the
                fast-paced crypto world
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🤝</span>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">
                Collaborate
              </h3>
              <p className="text-slate-600">
                Success is a team sport. We work together, share knowledge, and
                support each other
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">💡</span>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">
                Innovate
              </h3>
              <p className="text-slate-600">
                We challenge the status quo and continuously explore new ways to
                create value
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
